import React, { Component } from 'react'
import { Card, CardBody, Row, Col, Input } from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { contenidosFetch } from '../../redux/actions/aContenidos';
import { dataCoberturas } from '../../redux/selectors/sPymes';
import ValoresCobertura from '../../components/CotizacionPymes/CotizacionPymes4/ValoresCobertura';
import CoberturaGeneralPymes from '../../components/CotizacionPymes/CotizacionPymes4/CoberturaPymes/CoberturaGeneralPymes';
import CoberturaUbicacionPymes from '../../components/CotizacionPymes/CotizacionPymes4/CoberturaPymes/CoberturaUbicacionPymes';



class ContainerCoberturaPymes extends Component {
    constructor(props) {
        super(props)
        const ubSelec = 0
        const generales = {
            gastosPorRemocionDeEscombros: 0,
            gastosPorHonorariosDeProfesionales: 0
        }
        this.state = { ubSelec, arrayData: [[]], nota: [], guardar: false, generales, estadoGenerales: false, bloquearRegresar: this.props.volverResumen ? this.props.volverResumen : false, estadoActualizar: false, hasSiguienteUbicacion: true }
        // binding es necesario, para cuando se haga la llamada callback desde el componente hijo
        this.setEstadoActualizar = this.setEstadoActualizar.bind(this);
    }
    handleClick = async (datos, i, coberturaEspecial = true) => {
        // props
        const { idCobertura } = this.props
        // visualizar variables de estado del componente
        const { ubSelec, arrayData, nota, guardar, generales, estadoGenerales, estadoActualizar, hasSiguienteUbicacion } = this.state
        // copias de las variables de estado, para no editar el estado directamente
        let stateArrayData
        let stateGuardar
        let stateNota
        let stateGenerales
        let stateEstGenerales
        let stateEstActualizar
        let stateUbSelec
        let stateHasSiguienteUbicacion

        // variables internas                
        let ubicaciones = []

        // Si va a actualizar los valores del tab el usuario
        if (estadoActualizar || !coberturaEspecial) {
            stateUbSelec = ubSelec
            stateHasSiguienteUbicacion = hasSiguienteUbicacion
            // deep copy y agregar el dato correspondiente al tab            
            stateArrayData = [...arrayData]
            if (Array.isArray(datos) && datos.length !== 0) {
                let tabToModify = [...stateArrayData[i]]
                tabToModify = datos
                stateArrayData[i] = tabToModify
            }

            // Llamar al servicio para guardar los datos llenados en el tab
            let res
            res = await this.props.guardarCobertura({ arrayData: stateArrayData, idCobertura, generales })

            // Manejar la respuesta del servicio
            if (res && res.transaccion) {
                stateNota = res.nota ? res.nota : []
                ubicaciones = res.ubicaciones
                stateEstGenerales = res.estadoGenerales
                stateGenerales = res.generales
                let stateArrayData2 = []
                stateArrayData.forEach((item, i) => {
                    let valorItem = []
                    item.forEach((elem, j) => {
                        const val = { ...elem, value: (ubicaciones[i])[elem.codigo] }
                        valorItem.push(val)
                    })
                    stateArrayData2.push(valorItem)
                })
                if (stateArrayData2) {
                    stateArrayData = stateArrayData2
                }
                stateGuardar = true
                stateEstActualizar = false
                // Manejo de botón exterior de actualizar, para cuando se llama en coberturas generales
                if (!coberturaEspecial) {
                    this.setState({ estadoActualizar: false })
                }
            } else {
                stateUbSelec = ubSelec
                stateGuardar = guardar
            }
            // update state
            this.setState({
                ubSelec: stateUbSelec !== undefined ? stateUbSelec : ubSelec,
                arrayData: stateArrayData !== undefined ? stateArrayData : arrayData,
                nota: stateNota !== undefined ? stateNota : nota,
                guardar: stateGuardar !== undefined ? stateGuardar : guardar,
                generales: stateGenerales !== undefined ? stateGenerales : generales,
                estadoGenerales: stateEstGenerales !== undefined ? stateEstGenerales : estadoGenerales,
                estadoActualizar: stateEstActualizar !== undefined ? stateEstActualizar : estadoActualizar
            })

            if (!guardar) window.scroll(0, 0)
            else window.scroll(0, 400)
        }
        else {
            // condiciones para ir a la siguiente ubicación de la cobertura actual
            if (guardar && !estadoActualizar && ubSelec < arrayData.length - 1) {
                stateUbSelec = ubSelec + 1
                stateHasSiguienteUbicacion = true
                // this.setState({hasSiguienteUbicacion:true})
                console.log('reachable')
                // detectar cuando ya se recorrieron todas las ubicaciones para una cobertura
                if (stateUbSelec === arrayData.length - 1) {
                    stateHasSiguienteUbicacion = false
                    // this.setState({hasSiguienteUbicacion:false})
                    console.log('unreachable')
                }
            }

            // update state
            this.setState({
                ubSelec: stateUbSelec !== undefined ? stateUbSelec : ubSelec,
                hasSiguienteUbicacion: stateHasSiguienteUbicacion !== undefined ? stateHasSiguienteUbicacion : hasSiguienteUbicacion
            })
        }

    }

    componentDidMount() {
        if (this.props.esCoberturaPorUbicaciones) {
            this.generarArrayData()
        }

        console.log('initiated')
        this.setState({ estadoActualizar: true })
    }

    handleBack = () => {
        this.setState({ hasSiguienteUbicacion: true })
        let { ubSelec } = this.state
        if (ubSelec === 0)
            this.props.handleAtras()
        else {
            ubSelec--
            this.setState({ ubSelec })
        }
    }

    generarArrayData = () => {
        console.log('dataProps', this.props, this.state)
        const { arrayUbicaciones, data } = this.props

        let arrayData = []
        arrayUbicaciones.forEach(({ incendioAliadas }) => {
            let data2 = []
            if (data) {
                data.forEach(item => data2.push({ ...item, value: 0 }))

                if (incendioAliadas) {

                    let data3 = []
                    data2.forEach(item => {
                        let value = incendioAliadas[item.codigo]
                        data3.push({ ...item, value })
                    })
                    data2 = data3;
                }
                arrayData.push(data2)
            }

        })

        const { ubicaciones } = this.props
        console.log(ubicaciones)
        if (ubicaciones) {
            let arrayData2 = []
            arrayData.forEach((item, i) => {
                let valorItem = []
                item.forEach((elem, j) => {
                    const val = { ...elem, value: (ubicaciones[i])[elem.codigo] }
                    valorItem.push(val)
                })
                arrayData2.push(valorItem)
            })
            arrayData = arrayData2
        }

        this.setState({ arrayData })
    }

    handleGenerales = (valor, codigo, maximo) => {
        valor = parseFloat(valor)
        console.log('VALOR1', valor)
        if (isNaN(valor)) valor = 0
        console.log('VALOR2', valor)
        if (valor >= 0) {
            maximo = parseFloat(maximo)
            if (valor <= maximo) {
                let { generales } = this.state
                generales = { ...generales, [codigo]: valor }
                this.setState({ generales, estadoActualizar: true })
            }
        }
    }

    // set para el estado actualizar, que se activa cuando el usuario edita los valores
    setEstadoActualizar = (value) => {
        this.setState({ estadoActualizar: value })
        console.log('clickActualizar', this.state.estadoActualizar, value)
    }

    render() {

        const { ubSelec, arrayData, nota = [], guardar, generales, estadoGenerales, bloquearRegresar } = this.state
        const { arrayUbicaciones, titulo, nombreGiro, idCobertura, cliCodigoCore, cobGenerales, esCoberturaGeneral, esCoberturaPorUbicaciones } = this.props
        console.log("DATA", this.props)
        console.log("rrr", arrayData)
        return (
            <Col md={8}>
                <div className='row' style={{ background: '#e8eaed', margin: 'auto', padding: 10, marginBottom: 10, }}>
                    <Col sm={6}> <h3 style={{ fontWeight: 700, color: '#b6207f', }}>{titulo}</h3> <div style={{}}> Por favor ingrese los valores que desea asegurar </div> </Col>
                    <Col sm={6} style={{ borderLeft: '2px solid #b3b4b6', }} > <h3 style={{ fontWeight: 700, }}> <center> Giro del negocio: </center> </h3> <div style={{ fontSize: '1.3rem', }}> <center> {nombreGiro} </center> </div>  </Col>
                </div>

                {esCoberturaGeneral && !esCoberturaPorUbicaciones &&
                    <CoberturaGeneralPymes
                        arrayUbicaciones={arrayUbicaciones}
                        titulo={titulo}
                        nombreGiro={nombreGiro}
                        esCoberturaGeneral={true}
                        esCoberturaPorUbicaciones={true}
                        idCobertura={idCobertura}
                        guardarCobertura={this.props.guardarCobertura}
                        handleAtras={this.props.handleAtras}
                        handleNext={this.props.handleNext}
                        volverResumen={this.props.volverResumen}
                    />
                }

                {esCoberturaGeneral && esCoberturaPorUbicaciones &&
                    <CoberturaUbicacionPymes
                        arrayUbicaciones={arrayUbicaciones}
                        titulo={titulo}
                        nombreGiro={nombreGiro}
                        esCoberturaGeneral={true}
                        esCoberturaPorUbicaciones={true}
                        idCobertura={idCobertura}
                        guardarCobertura={this.props.guardarCobertura}
                        handleAtras={this.props.handleAtras}
                        handleNext={this.props.handleNext}
                        volverResumen={this.props.volverResumen}
                    />
                }



                {nota.length > 0 &&
                    <div className='row card'>
                        <Col md={12} className='card-body' style={{ background: '#fff', }}>
                            <label style={{ fontWeight: 700, }}> Nota: </label>
                            {console.log('nota_es', nota)}
                            {nota.map((item, i) => <p key={`notasCober${Math.random()}`} >{item}</p>)}
                        </Col></div>}

            </Col>
        )
    }
}
const mapStateToProps = (state, props) => ({
    coberturas: state.dataPymes.maxCoberturas,
    cobGenerales: state.dataPymes.coberturasGenerales[props.idCobertura],
    data: dataCoberturas(state, props),
    cliCodigoCore: state.datosUsuarios.dataUsuario.cliCodigoCore,
})

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(ContainerCoberturaPymes)
);